import React, {Component} from "react";
import {Alert, FormGroup, Row, Col, Label, Modal, Button} from "reactstrap";
import {Formik, Field, Form, ErrorMessage} from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import {sectionsCompaniesList, sectionsNew, sectionsEdit} from "../../store/sections/actions";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {capitalizeFirst, removeEmptyFormField} from "../../common/general";
import SelectField from "../../components/Common/SelectField";

class NewModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      companiesData: [],
      loading: false,
      error: ""
    }
  }

  componentDidMount() {
    const {onSectionsCompaniesList} = this.props;
    onSectionsCompaniesList({history: this.props.history});
  }

  onClose = () => {
    this.props.togModal()
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        companiesData: this.props.responseCompaniesList ? this.props.responseCompaniesList.response : null,
        loading: this.props.loading,
        error: this.props.error
      });
      if (this.props.responseNew.status === 0) {
        this.props.sectionsRefresh({history: this.props.history})
        this.onClose()
      }
    }
  }

  render() {
    const requiredName = Yup.string().required("Please Enter Section Name")

    return (<React.Fragment>
      <Modal isOpen={true} toggle={this.onClose}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            {capitalizeFirst(this.props.action)} Section
          </h5>
          <button type="button" onClick={this.onClose} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <Formik
          initialValues={{
            name: this.props.action === "new" ? "" : this.props.sectionData.name,
            company: this.props.sectionData.company,
          }}
          validationSchema={Yup.object().shape({
            name: Yup.string().min(3, 'Section Name Is Too Short').max(32, 'Section Name Is Too Long').concat(this.props.action === "new" ? requiredName : null),
          })}
          onSubmit={values => {
            const {onSectionsNew, onSectionsEdit} = this.props
            if (this.props.action === "new") {
              onSectionsNew({history: this.props.history, values: {...values, company: values.company.value}})
            } else {
              if (values.company === null) {
                values = {
                  ...values,
                  company: "",
                }
                values = removeEmptyFormField(values)
                values = {
                  ...values,
                  company: null,
                }
              } else {
                values = removeEmptyFormField({...values, company: values.company.value})
              }
              onSectionsEdit({history: this.props.history, id: this.props.sectionData.id, values: values})
            }
          }}
        >
          {({errors, status, touched}) => (<Form>
            <div className="modal-body">
              <Row>
                <Col lg="12" className="mb-1">
                  <FormGroup>
                    <Label htmlFor="name">
                      Name
                    </Label>
                    <Field
                      id="name"
                      name="name"
                      placeholder="Enter Section Name"
                      type="text"
                      className={"form-control" + (errors.name && touched.name ? " is-invalid" : "")}
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                  <FormGroup>
                    <SelectField label="Company" name="company" options={this.state.companiesData}/>
                  </FormGroup>
                </Col>
              </Row>
            </div>
            <div className="modal-footer">
              {this.state.loading && (<div className="spinner-border text-primary m-1 me-auto" role="status">
                <span className="sr-only">Loading...</span>
              </div>)}
              {this.state.error.length > 0 && (<Alert color="danger" role="alert" className="me-auto">
                {this.state.error}
              </Alert>)}
              <Button color="secondary" onClick={this.onClose} data-dismiss="modal">
                Close
              </Button>
              <Button color="primary" type="submit">
                Save
              </Button>
            </div>
          </Form>)}
        </Formik>
      </Modal>
    </React.Fragment>)
  }
}

NewModal.propTypes = {
  responseCompanies: PropTypes.any,
  response: PropTypes.any,
  onSectionsNew: PropTypes.func,
  onSectionsEdit: PropTypes.func,
};

const mapStateToProps = ({Sections}) => ({
  responseCompaniesList: Sections.responseCompaniesList,
  responseNew: Sections.responseNew,
  loading: Sections.loadingNew,
  error: Sections.errorNew,
});

const mapDispatchToProps = dispatch => ({
  onSectionsCompaniesList: data => dispatch(sectionsCompaniesList(data)),
  onSectionsNew: data => dispatch(sectionsNew(data)),
  onSectionsEdit: data => dispatch(sectionsEdit(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(NewModal));